import "@vitejs/plugin-react/preamble";
import "core-js/stable";
import "regenerator-runtime/runtime";
import smoothscroll from "smoothscroll-polyfill";
import Rails from "@rails/ujs";
import { configure as configureAxios } from "app/axios";
import "index";

smoothscroll.polyfill();

// Eagerly include the image tree so Vite can fingerprint assets that were
// previously pulled in via Webpack's require.context.
import.meta.glob("../images/**/*", { eager: true });

Rails.start();
configureAxios();
